import { Permissions } from '../../../models/enums/permissions';
import * as React from 'react';
import { InputLabel } from '../../../components/form-elements/_index';
import { AddressMapDisplay } from '../../../transportation/components/mapping/AddressMapDisplay';
import { AppUtils } from '../../../utils/app-utils';
import { hasPermission } from '../../../containers/authorization-helpers/has-permission';

interface IProps {
    label                   : string;
    name                    : string;
    addressLine1            : string;
    addressLine2            : string;
    city                    : string;
    state                   : string;
    postalCode              : string;
    phoneNumber?            : string;
    latitude?               : number;
    longitude?              : number;
    onClick?                : any;
    canEditPhoneNumber?     : boolean;
    phoneNumberChanged?     : any;
}

export const AddressDisplay = (props: IProps) => {

    const line1 = props.addressLine1 ? props.addressLine1.replace(' ', '+') : '';
    const city = props.city ? props.city.replace(' ', '+') : '';
    const state = props.state ? props.state.replace(' ', '+') : '';
    const zip = props.postalCode ? props.postalCode.replace(' ', '+') : '';

    const latlng = {
        lat: props.latitude,
        lng: props.longitude
    };

    const adminPermission = Permissions.SupportDealersAddressOverride;

    const urlAddr = `${line1},+${city},+${state}+${zip}`;

    const urlDisplay = `${props.name}\n${props.addressLine1}\n${props.addressLine2 ? `${props.addressLine2}\n` : ''}${props.city}, ${props.state} ${props.postalCode}`;

    const _onPhoneNumberChanged = (evt: any) => {
        props.phoneNumberChanged(evt);
    };

    return props
            ? <div className="row">
                <div className="col-md-12">
                    <div className="form-group address-display">
                        <InputLabel
                            htmlFor="">
                            {props.label}
                        </InputLabel>

                        <div className="row">
                            <div className="col-md-6">                            
                                    
                                <div className="form-group">
                                    <textarea
                                        id='address-line1'
                                        className="form-control"
                                        disabled
                                        value={ urlDisplay }
                                        onChange={ () => { return; }}
                                    />
                                </div>

                            {
                                    <div className="form-group">
                                        <input
                                        id='address-phone'
                                        className="form-control"
                                        type="text"
                                        disabled={!props.canEditPhoneNumber || !hasPermission({ requiredPermissions: [adminPermission] })}
                                        value={`tel: ${AppUtils.formatPhone(props.phoneNumber ?? '')}`}
                                        onChange={ _onPhoneNumberChanged }
                                        />
                                    </div>
                                }
                            </div>

                            <div className="col-md-6">
                                <div className="location">
                                    {
                                        (props.latitude && props.longitude) || urlAddr.length > 5
                                            ? <AddressMapDisplay
                                                onClick={ props.onClick }
                                                center={ latlng } />
                                            : <div className="no-address">Unable to load address</div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
            : null;

};
